import { c as _c } from "react-compiler-runtime";
import React from "react";
import { DatePicker } from "./DatePicker.js";
import * as styles from "./DateRange.css.js";
import { FCTextFieldContext } from "./TextFieldContext.js";
import useI18n from "./internal/useI18n.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const forwardedKeys = ["value", "defaultValue", "onChange", "name", "loadingState", "onFocus", "onBlur"];
function extractDatePickerProps(props, prefix) {
  const result = {};
  for (const key of forwardedKeys) {
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
    const prefixedKey = `${prefix}${capitalizedKey}`;
    if (prefixedKey in props) {
      // @ts-expect-error - This is safe because we're checking if the key exists
      result[key] = props[prefixedKey];
    }
  }
  return result;
}
const BaseDateRange = (t0, ref) => {
  const $ = _c(27);
  let left;
  let props;
  if ($[0] !== t0) {
    ({
      left,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = left;
    $[2] = props;
  } else {
    left = $[1];
    props = $[2];
  }
  const i18n = useI18n();
  const fcLabelProps = React.useContext(FCTextFieldContext);
  let t1;
  if ($[3] !== props) {
    t1 = extractDatePickerProps(props, "from");
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const fromProps = t1;
  let t2;
  if ($[5] !== props) {
    t2 = extractDatePickerProps(props, "to");
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const toProps = t2;
  const label = fcLabelProps.label ?? "";
  if (label.length === 0 && process.env.NODE_ENV !== "production") {
    console.warn("DateRange component is missing a label. This may cause accessibility issues.");
  }
  let t3;
  if ($[7] !== left) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: styles.left,
      children: left
    });
    $[7] = left;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== i18n || $[10] !== label) {
    t4 = i18n.format("dateRangeFrom", {
      label
    });
    $[9] = i18n;
    $[10] = label;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== fromProps || $[13] !== t4) {
    t5 = /*#__PURE__*/_jsx("div", {
      className: styles.from,
      children: /*#__PURE__*/_jsx(DatePicker, {
        ...fromProps,
        slot: "from",
        "aria-label": t4
      })
    });
    $[12] = fromProps;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: styles.separator,
      children: " - "
    });
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== i18n || $[17] !== label) {
    t7 = i18n.format("dateRangeTo", {
      label
    });
    $[16] = i18n;
    $[17] = label;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7 || $[20] !== toProps) {
    t8 = /*#__PURE__*/_jsx("div", {
      className: styles.to,
      children: /*#__PURE__*/_jsx(DatePicker, {
        ...toProps,
        skipLabelClickListener: true,
        slot: "to",
        "aria-label": t7
      })
    });
    $[19] = t7;
    $[20] = toProps;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== ref || $[23] !== t3 || $[24] !== t5 || $[25] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      ref: ref,
      className: styles.content,
      children: [t3, t5, t6, t8]
    });
    $[22] = ref;
    $[23] = t3;
    $[24] = t5;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export const DateRange = /*#__PURE__*/React.forwardRef(BaseDateRange);
//# sourceMappingURL=DateRange.js.map